import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourers`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function terminated(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    };

    return axios.get(`${url}/labourers/terminated`, options)
        .then(response => {
            return {
                terminated: response.data.data,
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourers/${id}?include=skills,parents,educations.exam,port,department`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function view(params) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourers/${params.id}?include=${params.include}`, options)

        .then(response => {
            let labourer = jsona.deserialize(response.data);
            delete labourer.links;
            return labourer;
        });
}


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourers/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add(labourer) {
    const payload = jsona.serialize({
        stuff: labourer,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourers`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(labourer) {
    const payload = jsona.serialize({
        stuff: labourer,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/labourers/${labourer.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function syncPunch(labourer) {

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourer/sync/punchs/${labourer.id}`, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/labourers/${id}`, options);
}


function upload(labourer, image) {
    const bodyFormData = new FormData();
    bodyFormData.append('attachment', image);
    console.log(bodyFormData);
    return axios.post(`${url}/uploads/labourers/${labourer.id}/image`, bodyFormData)
        .then(response => {
            return response.data.url;
        });
}

function downloadTemplate() {
    return axios({
        url: `${url}/labourers/template`,
        method: "GET",
        responseType: "blob",
    }).then(response => response.data);
}

function getStatusStatistics (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourers/status/stats`, options)
        .then(response => {
            console.log(response.data.data);
            return response.data.data ? response.data.data : [];
        });

}
function updateStatus(payload) {
    const options = {

        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(

        `${url}/labourer/status/${payload.data.id}`,

        payload,

        options

    ).then(response => {

        return response.data;
    });
}
function activateToVendor(id, payload) {

    return axios.post(
        `${url}/labourers/${id}/activate-to-vendor`,
        payload,
        {
            headers: {
                Accept: 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
        }
    ).then(response => response.data);
}

function searchByNidaAndPhone(payload) {
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    };

    return axios.post(
        `${url}/public/labourer-search`,
        payload,
        options
    ).then(response => {
        return response.data;
    });
}

function fetchReadiness(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourers/readiness`, options)
        .then(response => {
            return {
                list:response.data.data,
                meta: response.data.meta
            };
        });
}

function syncBiotime(params) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourers/sync/biotimeInfo/${params.id}`, options)

        .then(response => {
            let labourer = jsona.deserialize(response.data);
            delete labourer.links;
            return labourer;
        });
}

function registrationBiotime(params) {
    const { id, force_creation = false, ...extraParams } = params;

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    const payload = {};

    if (force_creation !== undefined && force_creation !== null) {
        payload.force_creation = force_creation;
    }
    if (extraParams && Object.keys(extraParams).length > 0) {
        Object.assign(payload, extraParams);
    }

    return axios.post(`${url}/labourers/biotime/registration/${id}`, payload, options)
        .then(response => {
            let labourer = jsona.deserialize(response.data);
            delete labourer.links;
            return labourer;
        });
}
function syncBiotimeAreas(payload) {
    return axios.post(
        url + '/labourers/' + payload.labourer_id + '/sync-biotime-areas',
        { biotime_area_ids: payload.biotime_area_ids },
        { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    ).then(function (response) {
        return response.data;
    });
}

export default {
    list,
    terminated,
    get,
    view,
    show,
    add,
    update,
    destroy,
    upload,
    getStatusStatistics,
    updateStatus,
    activateToVendor,
    searchByNidaAndPhone,
    syncPunch,
    syncBiotime,
    fetchReadiness,
    registrationBiotime,
    downloadTemplate,
    syncBiotimeAreas
};

